// extracted by mini-css-extract-plugin
module.exports = {"bottomLink":"BottomLinkItem_bottomLink__b4Kk-","label":"BottomLinkItem_label__1BAnH","link":"BottomLinkItem_link__1WGg2"};